import { Swiper } from 'swiper';

export default class{

    /**
     * constructor
     */
    constructor(){
        this.slider = document.querySelectorAll('[data-article-slider]');
    }

    /**
     * init
     */
    init(){
        this.slider.forEach(slider => {
            new Swiper(slider, {
                slidesPerView: 1.5,
                spaceBetween: 20,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 56
                    }
                }
            });
        });
    }

}